import React ,{ Component }from "react";
import { FiCast , FiLayers , FiUsers , FiMonitor } from "react-icons/fi";

const ServiceList = [
    {
      icon: <FiCast />,
      title: 'Estrategia de Negocios',
      description: 'Diseñamos estrategias integrales para potenciar tu marca y alcanzar tus objetivos de negocio.'
    },
    {
      icon: <FiLayers />,
      title: 'Desarrollo Web',
      description: 'Creamos sitios web atractivos y funcionales que impulsan la presencia en línea de tu empresa.'
    },
    {
      icon: <FiUsers />,
      title: 'Marketing y Análisis',
      description: 'Implementamos campañas de marketing digital con seguimiento detallado para maximizar tus resultados.'
    },
    { 
      icon: <FiMonitor />,
      title: 'Desarrollo de Aplicaciones Móviles',
      description: 'Desarrollamos aplicaciones móviles intuitivas que conectan a tu negocio con tus clientes en cualquier lugar.'
    },
    {
      icon: <FiUsers />,
      title: 'Marketing y Análisis',
      description: 'Estrategias personalizadas que combinan creatividad y datos para impulsar el crecimiento de tu marca.'
    },
    { 
      icon: <FiMonitor />,
      title: 'Desarrollo de Aplicaciones Móviles',
      description: 'Aplicaciones innovadoras que mejoran la experiencia del usuario y facilitan la interacción con tu marca.'
    }
  ];
  


class ServiceThree extends Component{
    render(){
        const {column } = this.props;
        const ServiceContent = ServiceList.slice(0 , this.props.item);
        
        return(
            <React.Fragment>
                <div className="row">
                    {ServiceContent.map( (val , i) => (
                        <div className={`${column}`} key={i}>
                            <a href="/service-details">
                                <div className="service service__style--2">
                                    <div className="icon">
                                        {val.icon}
                                    </div>
                                    <div className="content">
                                        <h3 className="title">{val.title}</h3>
                                        <p>{val.description}</p>
                                    </div>
                                </div>
                            </a>
                        </div>
                    ))}
                </div>
            </React.Fragment>
        )
    }
}
export default ServiceThree;
